import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import OperatorApplicationMessageStatus from "~/operatorApplication/ts/service/dialog/OperatorApplicationMessageStatus";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import Typing from "~/operatorApplication/ts/service/comet/listeners/Typing";
import OperatorTyping from "~/operatorApplication/ts/service/comet/listeners/OperatorTyping";
//import AutoInvisible from "~/operatorApplication/ts/service/status/AutoInvisible";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {
    OPERATOR_LOGGED_OUT,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import Dictionary from "~/ts/library/Dictionary";
import showNotificationAboutClientMessage
    from "~/operatorApplication/ts/service/dialog/ShowNotificationAboutClientMessage";
import playNotificationSoundAboutClientMessage
    from "~/operatorApplication/ts/service/dialog/PlayNotificationSoundAboutClientMessage";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";

let dialogs: Dictionary<number> = {};

export default class NewMessage extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "newMessage";
    }

    public async receive(payload: CometOperatorApplication.NewMessageCometMessageOpenApiModel) {

        let message = payload.message;
        let messageTypeId = message.messageType?.id;
        if (messageTypeId) {
            let messageType = OperatorAccountStore.messageTypeDictionary.value[message.messageType?.id];
            if (messageType) {
                message.messageType = messageType;
            }
        }
        ClientUserdataStore.addMessage({message});

        if (message.isSendByClient/* || message.isCrossOperatorsChat*/) {
            if (!OperatorAccountStore.isCabinetIframe) {
                let client = await ClientUserdataStore.getByUsernameAsync(message.username);
                if (client) {
                    OperatorApplicationMessageStatus.setMessageStatusDelivered(client, message);

                    if (message.displayNotification) {
                        let isNewDialog = dialogs[message.username] != message.dialogId;
                        dialogs[message.username] = message.dialogId;
                        let showNotification = true;
                        if (OperatorApplicationPlatformFactory.window.isFocusAvailable()) {
                            if (OperatorApplicationConfigInstance.skipMessageNotificationWhenFocusedAndSelected) {
                                if (client.username == ClientUserdataStore.selectedUsernameInSelectedSection.value) {
                                    if (OperatorApplicationPlatformFactory.window.isFocused()) {
                                        showNotification = false;
                                    }
                                }
                            }
                        }
                        if (showNotification) {
                            if (!payload.notificationConfig || payload.notificationConfig.isNotificationDisplayed) {
                                if (CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(client)) {
                                    let operator = OperatorAccountStore.operatorsDictionary.value[payload.message.operatorLogin];
                                    if (operator) {
                                        if (!payload.notificationConfig) {
                                            payload.notificationConfig = {
                                                isNotificationDisplayed: true,
                                                isSoundEnabled: true,
                                                avatarUrl: operator.avatar
                                            };
                                            if (OperatorAccountStore.crossOperatorChat.value[client.username]?.group) {
                                                payload.notificationConfig.title = `${operator.fio} → ${client.displayDescr}`;
                                            }
                                        }
                                    }
                                }
                                showNotificationAboutClientMessage(client, message.text, undefined, payload.notificationConfig);
                            }
                            playNotificationSoundAboutClientMessage(
                                client,
                                isNewDialog,
                                false,
                                payload.notificationConfig
                            );
                        }
                        if (!CoreUiChatHistoryHelper.isOneOfCrossOperatorsChatMessage(message)) {
                            if (isNewDialog) {
                                ClientUserdataStore.setClientWithNewDialog(message.username);
                            }
                        }

                        if (OperatorApplicationPlatformFactory.isNative) {
                            let focus = isNewDialog ? OperatorApplicationConfigInstance.newDialogWindowFocus : OperatorApplicationConfigInstance.newMessageWindowFocus;
                            if (focus) {
                                OperatorApplicationPlatformFactory.window.focus();
                            }
                        }
                    }
                }

            }
        }


        if (message.isSendByClient) {
            //AutoInvisible.receiveMessage(message);
            Typing.clear(message.username);
        } else {
            //AutoInvisible.sendMessage(message);
            OperatorTyping.clear(message.username, message.operatorLogin);
        }
    }

}

OperatorApplicationEventManager.addEventListener(OPERATOR_LOGGED_OUT, () => {
    dialogs = {};
});
